import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_RO.json';
import guides from './MEDITATION_GUIDES_RO.json';

export const MEDITATION_DATA_RO: ServiceData = {
  audios,
  guides,
};
